module.exports = __webpack_public_path__ + "static/img/sf-item-03.0ed216d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-03.png
// module id = enxg
// module chunks = 2